import Button from './Button.jsx'
import './ButtonBar.scss'
import FormInput from './FormInput.jsx'
import Select from 'react-select'
import { reactSelectStyles } from './SelectField'
import DatePicker from 'react-date-picker'

import 'react-calendar/dist/Calendar.css'

/**
 * Button bar component, handles showing a search field and CTAs.
 *
 * @param {(value) => void} onSearch - A callback, if provided with show a search field.
 * @param {Array<{label: string, onClick: () => void, type: Button.type}>} buttons - An array of buttons to show.
 */
export default function ButtonBar({ children }) {
  return <div className='button-bar'>{children}</div>
}

ButtonBar.Button = function ButtonBarButton({ label, onClick, type }) {
  return (
    <Button onClick={onClick} type={type || 'primary'}>
      {label}
    </Button>
  )
}

ButtonBar.MultiSelect = function MultiSelectFilter({ label, onChange, styles, list }) {
  return (
    <div className='select'>
      <Select placeholder={label} closeMenuOnSelect={false} options={list} styles={styles} onChange={onChange} isMulti />
    </div>
  )
}

ButtonBar.Select = function SelectFilter({ label, placeholder, onChange, value, list, isClearable = true }) {
  return (
    <div className='select'>
      <Select title={label} placeholder={placeholder} options={list} value={value} onChange={(value) => onChange(value || {})} isClearable={isClearable} />
    </div>
  )
}

ButtonBar.DateRange = function DateRangeFilter({ label, onChange, value, startLabel = 'From', endLabel = 'To' }) {
  const startDateValue = value && value[0] ? value[0] : ''
  const endDateValue = value && value[1] ? value[1] : ''

  const handleDateChange = (dateString, isStart) => {
    const currentRange = value || [null, null]
    const newRange = [...currentRange]

    if (dateString) {
      newRange[isStart ? 0 : 1] = dateString
    } else {
      newRange[isStart ? 0 : 1] = null
    }

    // Validate that end date is not before start date
    if (newRange[0] && newRange[1]) {
      const startDate = new Date(newRange[0])
      const endDate = new Date(newRange[1])

      if (endDate < startDate) {
        // If end date is before start date, clear the conflicting date
        if (isStart) {
          // If user changed start date, clear the end date
          newRange[1] = null
        } else {
          // If user changed end date, clear the start date
          newRange[0] = null
        }
      }
    }

    // Clear the range if both dates are null
    if (!newRange[0] && !newRange[1]) {
      onChange(undefined)
    } else {
      onChange(newRange)
    }
  }
  return (
    <div className='date-range-container'>
      {label && <span className='date-range-label'>{label}</span>}
      <div className='date-range-inputs'>
        <label className='atop'>
          <span>{startLabel}</span>
          <input
            type='date'
            className='forminput input'
            value={startDateValue}
            max={endDateValue || undefined} // Prevent selecting dates after end date
            onChange={(e) => handleDateChange(e.target.value, true)}
          />
        </label>
        <label className='atop'>
          <span>{endLabel}</span>
          <input
            type='date'
            className='forminput input'
            value={endDateValue}
            min={startDateValue || undefined} // Prevent selecting dates before start date
            onChange={(e) => handleDateChange(e.target.value, false)}
          />
        </label>
      </div>
    </div>
  )
}

ButtonBar.Date = function DateFilter({ label, onChange }) {
  return (
    <label className='atop'>
      <span>{label}</span>
      <DatePicker
        onChange={(values) => {
          onChange(values)
        }}
      ></DatePicker>
    </label>
  )
}

ButtonBar.Search = function SearchFilter({ label, placeholder, onChange }) {
  return <FormInput label={label} styles={reactSelectStyles} placeholder={placeholder} name='button-bar-search' onChange={onChange} atop inline />
}
